const MuteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={19}
      fill="none"
      viewBox="0 0 26 19"
    >
      <path d="M24.3333 5.66667L17.3333 12.6667M17.3333 5.66667L24.3333 12.6667M11.5 1L5.66667 5.66667H1V12.6667H5.66667L11.5 17.3333V1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default MuteIcon;
